var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "46px",
    viewBox: "0 0 46 46",
    width: "46px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46,12.517C46,9.193,43.307,6.5,39.982,6.5H6.017C2.694,6.5,0,9.193,0,12.517v20.967C0,36.807,2.694,39.5,6.017,39.5 h33.967c3.322,0,6.016-2.693,6.016-6.018V12.517z M41.927,14.597L29.001,28.65c-1.603,1.727-3.871,2.85-6.228,2.85 c-0.015,0-0.028,0-0.044,0c-2.372,0-4.647-1.159-6.242-2.915L3.563,14.306c-0.921-1.015-0.848-2.616,0.167-3.538 s2.583-0.866,3.504,0.146l12.924,14.207c0.664,0.73,1.611,1.146,2.597,1.152c0.989,0.031,1.938-0.408,2.608-1.133l12.928-13.918 c0.934-1.002,2.502-1.063,3.506-0.131C42.801,12.023,42.859,13.594,41.927,14.597z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.1f0a58033f8560620b983f2e9c4a8fb4.svg";
export { ForwardRef as ReactComponent };